export default __webpack_public_path__ + "static/media/FenrisTextBlack.66938389.svg";